import React, { useState } from "react";

const Legal = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size <= 15 * 1024 * 1024) { // 15 MB limit
      setSelectedFile(file);
      setFilePreview(URL.createObjectURL(file));
    } else {
      alert("File size exceeds 15 MB or invalid format.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file && file.size <= 15 * 1024 * 1024) { // 15 MB limit
      setSelectedFile(file);
      setFilePreview(URL.createObjectURL(file));
    } else {
      alert("File size exceeds 15 MB or invalid format.");
    }
  };

  const clearFile = () => {
    setSelectedFile(null);
    setFilePreview(null);
  };

  return (
    <div>
        <div className="clp-header">
            <h4 className='ws-title'>Finance & Legal</h4>
            <p className="ws-desc">Add finance & legal details for the new listing of your property.</p>
        </div>
      
        <div className="add-room-section hmfsb">
          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Ownership details</p>
              <p className="label-hint">Provide documents that proves your ownership</p>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <p>Type of ownership does the property have?</p>
                <div class="form-box">
                  <label for="checkInTime" class="form-label">Choose the ownership type</label>
                  <select class="form-select">
                      <option value="1">My Own Property</option>
                      <option value="2">Lease Property</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <p className="mb-0">Upload the registration document of the property</p>
                <p className="label-hint">The address on the registration document should match with the property address</p>
                <div
                  className={`upload-box ${filePreview ? "has-file" : ""}`}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  {filePreview ? (
                    <div className="file-preview">
                      {selectedFile.type.startsWith("image/") ? (
                        <img src={filePreview} alt="Preview" className="img-preview" />
                      ) : (
                        <p className="file-preview-text">Preview not available for PDF files.</p>
                      )}
                      <button type="button" className="btn-clear" onClick={clearFile}>
                        Remove File
                      </button>
                    </div>
                  ) : (
                    <div className="upload-instructions">
                      <p>Drag & Drop the Registration Document</p>
                      <p>or</p>
                      <label htmlFor="fileInput" className="upload-label">
                        <span>Click Here</span>
                      </label>
                      <p className="file-hint">(Upload PDF/PNG/JPG/JPEG files of up to 15 MB)</p>
                      <input
                        type="file"
                        id="fileInput"
                        className="file-input"
                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                        onChange={handleFileChange}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="add-room-section hmfsb">
          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Banking Details</p>
              <p className="label-hint">Enter Bank, PAN & GST Details</p>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <p>Bank Details</p>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="accountNumber" class="form-label">Account Number</label>
                  <input type="text" class="form-control" id="accountNumber" placeholder="Enter Account Number" />
                </div>
              </div>
              <div className='col-md-6'>
                <div className="form-box">
                  <label for="reAccountNumber" class="form-label">Re-enter Account Number</label>
                  <input type="text" class="form-control" id="reAccountNumber" placeholder="Enter Account Number" />
                </div>
              </div>
              <div className='col-md-6'>
                <div className="form-box">
                  <label for="ifsc" class="form-label">IFSC Number</label>
                  <input type="text" class="form-control" id="ifsc" placeholder="Enter IFSC Number" />
                </div>
              </div>
              <div className='col-md-6'>
                <div className="form-box">
                  <label for="bankName" class="form-label">Bank Name</label>
                  <input type="text" class="form-control" id="bankName" placeholder="Enter Bank Name" />
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="room-detail-box">
              <div className='dypxbs'>
                <div>
                  <p>Do you have a GSTIN?</p>
                </div>
                <div class="extra-bed-radio">
                  <div className='exdrs'>
                    <label>
                      <input type="radio" name="radio" checked="" />
                      <span>No</span>
                    </label>
                    <label>
                      <input type="radio" name="radio" />
                      <span>Yes</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <div className="form-box">
                    <label for="gstin" class="form-label">Enter GSTIN</label>
                    <input type="text" class="form-control" id="gstin" placeholder="Enter the 15 digit GSTIN" />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="form-box">
                    <label for="pancard" class="form-label">Enter PAN</label>
                    <input type="text" class="form-control" id="pancard" placeholder="Enter PAN" />
                  </div>
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="room-detail-box">
              <div className='dypxbs'>
                <div>
                  <p>Do you have a TAN?</p>
                </div>
                <div class="extra-bed-radio">
                  <div className='exdrs'>
                    <label>
                      <input type="radio" name="radio" checked="" />
                      <span>No</span>
                    </label>
                    <label>
                      <input type="radio" name="radio" />
                      <span>Yes</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <div className="form-box">
                    <label for="tanNumber" class="form-label">Enter TAN</label>
                    <input type="text" class="form-control" id="tanNumber" placeholder="Enter the 12 digit TAN" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
  );
};

export default Legal;
